import React, { useEffect, useState } from 'react';
import { List } from 'antd';
import { useSelector } from 'react-redux';
import {
  useSaveAnnotation,
  useSaveAnnotationComment,
} from '@components/annotations/hooks/useMutateAnnotation';
import { timeZoneOffsetSelector } from '@store/common/selectors';
import Editor from './Editor';
import { StyledCommentWrapper, StyledCommentListWrapper } from '../styled';
import AnnoComment from './Comment';

interface CommentItem {
  username: string;
  description: string;
  createdAt: string;
}

const CommentsComponent = ({ activeAnnotation, profile, setOpen }) => {
  const [comments, setComments] = useState<CommentItem[]>([]);
  const [value, setValue] = useState('');
  const tzOffset = useSelector(timeZoneOffsetSelector);

  const saveComment = useSaveAnnotationComment();
  const saveAnnotation = useSaveAnnotation();

  useEffect(() => {
    setComments(activeAnnotation.comments);
  }, [activeAnnotation]);

  const createAnnotation = () => {
    if (!value) return;
    // creating a new annotation
    if (activeAnnotation.annotationId === null) {
      saveAnnotation.mutate(
        { comment: value, activeAnnotation },
        {
          onSuccess: () => {
            setValue('');
            setOpen(false);
          },
        },
      );
    }
    // adding a comment
    else {
      saveComment.mutate(
        { comment: value, activeAnnotation },
        {
          onSuccess: () => {
            setValue('');
          },
        },
      );
    }
  };

  const onClear = () => {
    setValue('');
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  return (
    <StyledCommentWrapper>
      <Editor onClear={onClear} onChange={handleChange} onSubmit={createAnnotation} value={value} />
      {comments.length > 0 && (
        <StyledCommentListWrapper>
          <List
            dataSource={comments}
            header={`${comments.length} ${comments.length > 1 ? 'comments' : 'comment'}`}
            itemLayout="horizontal"
            renderItem={(item, index) => (
              <AnnoComment
                key={item.createdAt + index}
                item={item}
                profile={profile}
                index={index}
              />
            )}
          />
        </StyledCommentListWrapper>
      )}
    </StyledCommentWrapper>
  );
};

export default CommentsComponent;
